export const PORTFOLIO_UPDATE_OVERVIEW = 'PORTFOLIO_UPDATE_OVERVIEW';
export const PORTFOLIO_SET_OVERVIEW = 'PORTFOLIO_SET_OVERVIEW';
export const PORTFOLIO_UPDATE_DETAIL = 'PORTFOLIO_UPDATE_DETAIL';
export const PORTFOLIO_SET_DETAIL = 'PORTFOLIO_SET_DETAIL';

export const PORTFOLIO_UPDATE_PRIVATE_WEALTH = 'PORTFOLIO_UPDATE_PRIVATE_WEALTH';
export const PORTFOLIO_SET_PRIVATE_WEALTH = 'PORTFOLIO_SET_PRIVATE_WEALTH';
export const PORTFOLIO_UPDATE_PRIVATE_WEALTH_DETAIL = 'PORTFOLIO_UPDATE_PRIVATE_WEALTH_DETAIL';
export const PORTFOLIO_SET_PRIVATE_WEALTH_DETAIL = 'PORTFOLIO_SET_PRIVATE_WEALTH_DETAIL';
